class DpoPreloader extends HTMLElement {
  constructor() {
    super();
    this.variantObserver = null;
    this._fallbackTimer = null;
  }

  connectedCallback() {
    this.style.display = "block";
    const variantSelects = document.querySelector("variant-selects");

    if (variantSelects) {
      this._observeVariantSelects(variantSelects);
    }

    this._fallbackTimer = setTimeout(() => {
      if (variantSelects) variantSelects.classList.add("loaded");
      this._hide();
    }, 5000);

    waitForDpo(() => {
      clearTimeout(this._fallbackTimer);

      const dpoContainer = getDpoContainer();
      if (dpoContainer) dpoContainer.classList.add("loaded");

      if (variantSelects) {
        variantSelects.dataset.dpoLoaded = "true";

        if (variantSelects.style.display === "none") {
          this.variantObserver?.disconnect();
        } else {
          variantSelects.classList.add("loaded");
          this.variantObserver?.disconnect();
        }

        this._initVariantChangeListener(variantSelects);
      }

      this._hide();
    });
  }

  _observeVariantSelects(variantSelects) {
    this.variantObserver = new MutationObserver(() => {
      if (variantSelects.dataset.dpoLoaded !== "true") return;

      if (variantSelects.style.display === "none") {
        this.variantObserver.disconnect();
      } else {
        variantSelects.classList.add("loaded");
        this.variantObserver.disconnect();
      }
    });

    this.variantObserver.observe(variantSelects, {
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  _initVariantChangeListener(variantSelects) {
    const parent = variantSelects.parentElement;
    if (!parent) return;

    const observer = new MutationObserver(() => {
      const newVariantSelects = parent.querySelector("variant-selects");
      if (newVariantSelects && newVariantSelects.style.display !== "none") {
        newVariantSelects.classList.add("loaded");
      }
    });

    observer.observe(parent, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    clearTimeout(this._fallbackTimer);
    if (this.variantObserver) {
      this.variantObserver.disconnect();
      this.variantObserver = null;
    }
  }

  _hide() {
    this.remove();
  }
}

customElements.define("dpo-preloader", DpoPreloader);
